<template>
  <div class="event-modal-managers__wrapper">
    <h3 v-if="title" class="event-modal-managers__title">
      {{ $t("event.catalog.modal.managerTitle") }}
    </h3>

    <simplebar
      v-if="filterManagers && filterManagers.length"
      class="event-modal-managers__list"
    >
      <div
        v-for="manager in filterManagers"
        :key="`manager-${manager.id}`"
        class="event-modal-catalog-manager"
      >
        <div class="event-modal-catalog-manager__user">
          <template v-if="manager.image && manager.image.thumbnail_path">
            <img
              :src="getImage(manager)"
              :alt="getName(manager)"
              class="event-modal-catalog-manager__user-image"
            />
          </template>

          <template v-else>
            <img
              src="/public/static/images/event-no-company-image.svg"
              :alt="getName(manager)"
              class="event-modal-catalog-manager__user-image event-modal-catalog-manager__user-image_noimage"
            />
          </template>

          <div class="event-modal-catalog-manager__user-info">
            <p class="event-modal-catalog-manager__user-name">
              {{ getName(manager) }}
            </p>
            <p class="event-modal-catalog-manager__user-method">
              <a :href="mailto(manager.email)"> {{ manager.email }} </a>
            </p>
          </div>
        </div>
      </div>
    </simplebar>
  </div>
</template>

<script>
import { i18n } from "@v2/shared/config";
export default {
  name: "EventModalCatalogManager",

  props: {
    title: {
      type: Boolean,
      default: true
    },

    managers: Array
  },

  computed: {
    locale() {
      return i18n.locale;
    },

    filterManagers() {
      return this.managers.filter(
        item =>
          (this.locale === "en" && !!item.name_eng) ||
          (this.locale === "ru" && !!item.name_rus)
      );
    }
  },

  methods: {
    mailto(str) {
      return `mailto:${str}`;
    },

    getName(manager) {
      if (i18n.locale === "en") {
        return `${manager.lastname_eng} ${manager.name_eng} ${manager.middlename_eng}`;
      } else {
        return `${manager.lastname_rus} ${manager.name_rus} ${manager.middlename_rus}`;
      }
    },

    getPosition(manager) {
      return i18n.locale === "en" ? manager.position_eng : manager.position_rus;
    },

    getImage(manager) {
      return `${process.env.VUE_APP_URL}storage/${manager.image.thumbnail_path}`;
    }
  }
};
</script>
<style lang="scss">
.event-modal-managers__list {
  .ps__rail-x,
  .ps__rail-x:hover,
  .ps__rail-x.ps--clicking {
    @media (max-width: 739px) {
      height: 3px;
      background-color: rgba(0, 81, 151, 0.2);
    }
    @media (min-width: 740px) {
      display: none !important;
    }
  }
  .ps__thumb-x,
  .ps__rail-x:hover .ps__thumb-x,
  .ps__rail-x.ps--clicking .ps__thumb-x {
    @media (max-width: 739px) {
      bottom: 0;
      height: 3px;
      background-color: #005197;
    }
  }
  &.ps--active-x .ps__rail-x {
    @media (max-width: 739px) {
      opacity: 1;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-managers {
  &__title {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: #000000;

    margin: 10px 0 20px 0;

    @include respond-down(md) {
      font-size: 12px;
      margin-top: 0;
      margin-bottom: 8px;
    }
  }

  &__list {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    overflow-y: auto;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-bottom: 15px;

    @include respond-up(md) {
      overflow-y: hidden;
      flex-wrap: wrap;
      min-width: 100%;
      margin-left: 0;
      margin-right: -15px;
      padding-left: 0;
    }
  }
}

.event-modal-catalog-manager {
  width: 255px;
  min-width: 255px;
  padding-top: 15px;
  padding-right: 15px;
  box-sizing: border-box;

  @include respond-up(md) {
    width: 33.3333%;
    min-width: auto;
    margin-bottom: 10px;
  }
  &__user {
    display: flex;

    &-image {
      border-radius: 50%;

      width: 48px;
      height: 48px;

      margin-right: 20px;

      flex-shrink: 0;

      @include respond-down(md) {
        width: 40px;
        height: 40px;

        margin-right: 16px;
      }

      &_noimage {
        background: #f6f6f6;
      }
    }

    &-name {
      margin: 0 0 4px 0;
      font-size: 13px;
      line-height: 1.54;
      color: #000000;

      @include respond-down(md) {
        font-size: 12px;
        margin-bottom: 2px;
      }
    }

    &-method {
      margin: 0;

      a {
        @include hyperlink();

        @include respond-down(md) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
